/* pc-xsell.js: cross-sell block on product pages (2026-09-18). One-click add, headline that follows the cart, CornerCart refresh. No dependencies. */
/* Claude 2026-10-02 (v18 offre unique): once 2 charms are in the cart the headline only confirms the free bracelet + free shipping (no more 15% / 25% tier messages on the page). */
/* Claude 2026-10-10 (v21): gift choice at 2 charms -> texts use data-gift-label ("bracelet or key ring") instead of the bracelet price. */
(function () {
  var root = document.getElementById('pc-xsell');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');
  var d = root.dataset;
  var cfg = { gift: Number(d.gift) || 2, t1: Number(d.t1) || 3, p1: Number(d.p1) || 15, t2: Number(d.t2) || 5, p2: Number(d.p2) || 25, giftPrice: d.giftPrice || '', giftLabel: d.giftLabel || '', from: d.from || '', track: d.track === 'true', open: d.open === 'true' };
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ACC = /bracelet|jewelry box|key ring|gift set|gift card|safety chain|bundle|ebook/i;
  var sub = root.querySelector('[data-pc-sub]');
  var sub0 = sub ? sub.innerHTML : '';
  var timer;

  function more(n) { return n + ' more charm' + (n > 1 ? 's' : ''); }

  function paint(n, inCart) {
    if (sub) {
      var t;
      if (n <= 0) t = sub0;
      else if (n < cfg.gift) t = 'You have ' + n + ' charm' + (n > 1 ? 's' : '') + ' in your cart. Add ' + more(cfg.gift - n) + (cfg.giftLabel ? ' and get a <b>FREE</b> ' + cfg.giftLabel + ' (+ free shipping).' : ' and shipping is <b>FREE</b>.');
      else t = '✓ ' + (cfg.giftLabel ? 'Free ' + cfg.giftLabel + ' + free shipping unlocked — pick your gift in the cart.' : 'Free shipping unlocked.');
      sub.innerHTML = t;
    }
    var steps = root.querySelectorAll('[data-pc-step]');
    for (var i = 0; i < steps.length; i++) steps[i].classList.toggle('is-done', n >= Number(steps[i].getAttribute('data-pc-step')));
    var cards = root.querySelectorAll('.pc-xsell__card');
    for (var j = 0; j < cards.length; j++) {
      var btn = cards[j].querySelector('[data-pc-add]');
      if (!btn || btn.classList.contains('is-loading')) continue;
      var has = !!inCart[cards[j].getAttribute('data-handle')];
      if (has) { btn.textContent = 'In your cart ✓'; btn.disabled = true; }
      else if (btn.disabled) { btn.textContent = '+ Add'; btn.disabled = false; }
    }
  }

  function refresh() {
    fetch(R + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = 0, inCart = {};
        (cart.items || []).forEach(function (i) {
          inCart[i.handle] = true;
          if (i.final_line_price === 0 || ACC.test(i.product_title || '')) return;
          n += i.quantity;
        });
        paint(n, inCart);
      })
      .catch(function () {});
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 700); }

  function syncDrawer() {
    try {
      if (window.corner && typeof window.corner.do === 'function') {
        window.corner.do('refreshCart');
        if (cfg.open) setTimeout(function () { try { window.corner.do('openCart'); } catch (e) {} }, 350);
      }
    } catch (e) {}
  }

  root.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-pc-add]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.textContent = 'Adding…';
    var item = { id: Number(btn.getAttribute('data-pc-add')), quantity: 1 };
    if (cfg.track && cfg.from) item.properties = { _xsell: cfg.from };
    fetch(R + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.textContent = 'In your cart ✓';
        refresh();
        syncDrawer();
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        btn.textContent = 'Try again';
      });
  });

  /* keep the block in sync with any other cart change (main add to cart, drawer edits) without patching fetch */
  try {
    if (window.corner && typeof window.corner.on === 'function') window.corner.on('onCartEdit', schedule);
  } catch (e) {}
  try {
    if (window.PerformanceObserver) {
      new PerformanceObserver(function (list) {
        var hit = list.getEntries().some(function (en) { return /\/cart\/(add|change|update|clear)/.test(en.name); });
        if (hit) schedule();
      }).observe({ type: 'resource', buffered: false });
    }
  } catch (e) {}
  window.addEventListener('pageshow', schedule);

  /* the gift nudge under the buy button now jumps to this block instead of leaving the page */
  function hookNudge() {
    var link = document.querySelector('.pc-gift-nudge__link');
    if (!link || link.getAttribute('data-pc-hooked')) return;
    link.setAttribute('data-pc-hooked', '1');
    link.setAttribute('href', '#pc-xsell');
    link.addEventListener('click', function (e) {
      e.preventDefault();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  hookNudge();
  setTimeout(hookNudge, 1500);

  refresh();
})();
